/**
 * Layout trang công khai — Header thường + nội dung + footer.
 *
 * Dùng cho profile, favorites, chi tiết BĐS và các trang không cần HomeHeader.
 */
import { Outlet } from 'react-router-dom';
import { Footer } from '../components/Common/Footer';
import { Header } from '../components/Common/Header';

/** Shell layout public với Header và Footer chuẩn */
export const PublicLayout = () => (
  <div className="app-shell">
    <Header />
    <main>
      <Outlet />
    </main>
    <Footer />
  </div>
);
